<template>
  <section class="l-content-area">
    <div class="l-content l-content--reservation">
      <div class="l-wrap__outer">
        <div class="l-wrap__inner">
          <section class="c-title__bloc c-title__bloc--reservation">
            <h1>ご来店予約</h1>
            <div class="c-btn c-btn--title-back"><a href="#" @click="prevToStep()">戻る</a></div>
          </section>

          <section class="p-bloc p-bloc__reservation">
            <h2 class="p-reservation__step">STEP 4</h2>

            <div class="p-reservation__bloc">
              <p>担当者の指名有無を選択してください。</p>

              <div class="p-reservation__staff">
                <v-btn
                  v-for="(button, index) in buttons"
                  :key="index"
                  class="nominate__btn"
                  height="80"
                  elevation="0"
                  :ripple="false"
                  :disabled="isLoading"
                  @click="nextToStep(button.value)"
                >
                  <p class="nominate__btn__text">{{ button.text }}</p>
                  <img
                    src="../../../assets/img/ui_parts/service_bloc_arw.png"
                    class="icon"
                    alt=""
                  />
                </v-btn>
              </div>
            </div>

            <button-registration
              :is-next-button="false"
              :prev-text-color="'#787878'"
              :prev-text="'戻る'"
              :handle-prev-button="prevToStep"
            >
            </button-registration>
          </section>
          <!-- .p-bloc__reservation -->
        </div>
      </div>
    </div>
    <!-- .l-content--reservation -->
  </section>
  <!-- .l-content-area -->
</template>
<script>
import ButtonRegistration from '../../common/ButtonRegistration.vue'
import { requestRegisterReservation } from '../../../actions/requestMypage'

export default {
  name: 'MypageReservationPerson',
  components: {
    ButtonRegistration,
  },
  props: {
    currentStep: {
      type: String,
      default: '4',
    },
    isStaff: {
      type: Boolean,
      default: false,
    },
    storeId: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
    services: {
      type: Array,
      default: () => {
        return []
      },
    },
    reservationId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      buttons: [
        { text: '指名なし', value: 'apoint' },
        { text: '指名あり', value: 'person' },
      ],
      isLoading: false,
    }
  },
  methods: {
    prevToStep() {
      this.$emit('prevToStep')
    },
    nextToStep(value) {
      this.$emit('startLoading')
      this.isLoading = true

      if (value === 'apoint') {
        this.$emit('onChangeStep', 'isStaff', false)
        this.$emit('onHandleChange', 'stylistName', '')
        this.$emit('onHandleChange', 'stylist', null)
        this.$emit('onHandleChange', 'genderPreference', null)
        const dateTime = ''
        const isDesignCut = true

        requestRegisterReservation({
          reservationId: this.reservationId,
          currentStep: 4,
          userId: this.userId,
          storeId: this.storeId,
          timeVisited: dateTime,
          isDesignCut,
          services: this.services,
          status: null,
          stylist: null,
          genderPreference: null,
          waiting: 0,
          requestMsg: '',
        })
          .then((res) => {
            const {
              data: { success },
            } = res
            if (success && success === 1) {
              this.$emit('nextToStep')
            }
            this.$emit('endLoading')
          })
          .catch((err) => {
            this.$emit('endLoading')
            this.$router.push({ name: 'mypageError' })
            this.isLoading = false
            return err
          })
      }
      if (value === 'person') {
        // TODO: [investigate] Very much doubt isStaff is actually set here...
        this.$emit('onChangeStep', 'isStaff', true)
        this.$emit('nextToStep')
      }

      // Disable the button for 2 seconds
      setTimeout(() => {
        this.isLoading = false
      }, 2000)
      this.$emit('endLoading')
    },
  },
}
</script>
<style scoped>
.v-application ul,
.v-application ol {
  padding-left: 0 !important;
}

.v-application a {
  color: #0a005a;
}

/* Sorry, added custom classes here because the app's CSS files are ridiculous to track */
.nominate__btn {
  display: flex;
  justify-content: space-between;
  background-color: #f5f5f5;
  border: 2px solid #ebebeb;
  border-radius: 8px;
  color: #0b025a;
  width: 100%;
  align-items: center;

  &:last-child {
    margin-top: 15px;
  }
}

.nominate__btn__text {
  font-weight: bold;
  font-size: 18px;
  margin: 0;
}

.icon {
  width: 26px;
  height: 26px;
  margin-right: 6px;
}
</style>
